import React, { ReactNode } from 'react';
import AvatarContainer from '@/assets/images/avatars/avatar_container.png';
import BeltFrameWhite from '@/assets/images/avatars/belt_frame_white.svg';
import BeltFrameBlue from '@/assets/images/avatars/belt_frame_blue.svg';
import BeltFramePurple from '@/assets/images/avatars/belt_frame_purple.svg';
import BeltFrameBrown from '@/assets/images/avatars/belt_frame_brown.svg';
import BeltFrameBlack from '@/assets/images/avatars/belt_frame_black.svg';

interface FramedAvatarProps {
  src?: string;
  alt?: string;
  initials?: string;
  size?: number; // avatar size (inner circle), default 42
  frameSize?: { w: number; h: number }; // frame size, default {w:60, h:66}
  className?: string;
  showFrame?: boolean;
  beltRank?: string;
  fontSize?: number; // font size for initials (px)
}

export const FramedAvatar: React.FC<FramedAvatarProps> = ({
  src,
  alt = '',
  initials = '',
  size,
  frameSize = { w: 60, h: 66 },
  className = '',
  showFrame = true,
  beltRank,
  fontSize,
}) => {
  let frameImg = AvatarContainer;
  if (showFrame && beltRank) {
    switch (beltRank.toLowerCase()) {
      case 'white':
        frameImg = BeltFrameWhite;
        break;
      case 'blue':
        frameImg = BeltFrameBlue;
        break;
      case 'purple':
        frameImg = BeltFramePurple;
        break;
      case 'brown':
        frameImg = BeltFrameBrown;
        break;
      case 'black':
        frameImg = BeltFrameBlack;
        break;
      default:
        frameImg = AvatarContainer;
    }
  }
  // Dynamically calculate avatar size if not provided: 75.7% of frame height (proportional)
  const avatarSize = size !== undefined ? size : Math.round((frameSize.h || 66) * 0.757);
  const translateY = '-translate-y-[57%]';
  // Calculate font size for initials (default: 40% of avatar size)
  const initialsFontSize = fontSize !== undefined ? fontSize : Math.round((avatarSize || 24) * 0.4);
  return (
    <div
      className={`relative flex-shrink-0`}
      style={{ width: frameSize.w, height: frameSize.h }}
    >
      {src ? (
        <img
          key="avatar-image"
          src={src}
          alt={alt}
          className={`rounded-full border-2 border-black object-cover absolute left-1/2 top-1/2 -translate-x-1/2 ${translateY} z-10 ${className}`}
          style={{ width: avatarSize, height: avatarSize }}
        />
      ) : (
        <div 
          key="avatar-initials"
          className={`absolute left-1/2 top-1/2 -translate-x-1/2 ${translateY} rounded-full flex items-center justify-center z-10 bg-black`}
          style={{ width: avatarSize, height: avatarSize }}
        >
          <span 
            key="initials-text"
            className={`font-bold select-none text-white`} 
            style={{ fontSize: initialsFontSize }}
          >
            {initials}
          </span>
        </div>
      )}
      {showFrame && (
        <img
          key="avatar-frame"
          src={frameImg}
          alt="Avatar Frame"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-20"
          style={{ 
            width: frameSize.w, 
            height: frameSize.h
          }}
          onLoad={() => {
            if (beltRank?.toLowerCase() === 'white') {
              // console.log('🔄 FramedAvatar - Applied white belt frame');
            }
          }}
        />
      )}
    </div>
  );
}; 